import api from '@/api'

export default {
  login (user) {
    return api.post('/users/login', user)
  }
}



// WEBPACK FOOTER //
// ./src/services/authService.js